const params = new URLSearchParams(window.location.search);
const qLang = params.get("lang");
if (qLang === "he") localStorage.setItem("lang", "he");
else if (qLang === "en") localStorage.setItem("lang", "en");

const stored = localStorage.getItem("lang");
const browserHe = (navigator.language || "").toLowerCase().startsWith("he") ||
  (navigator.languages || []).some((l) => l.toLowerCase().startsWith("he"));

export const LANG =
  stored === "he" || stored === "en"
    ? stored
    : window.location.hostname.endsWith(".co.il") || browserHe
      ? "he"
      : "en";

export const HE = LANG === "he";

document.documentElement.lang = LANG;
document.documentElement.dir = HE ? "rtl" : "ltr";

if (LANG === "he") {
  document.title = "dev4u — בדיקת נראות AI בחינם";
  const d = document.querySelector("meta[name=\"description\"]");
  if (d) d.setAttribute("content", "בדקו תוך 30 שניות אם ChatGPT ממליץ על העסק שלכם — ציון נראות AI חינם + דוח מלא לוואטסאפ.");
}
